<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="详情"
    @ok="cancel"
    @cancel="cancel"
  >
    <a-descriptions title="任务要求" :column="2" bordered>
      <a-descriptions-item label="任务名称">
        {{ modal.workerName }}
      </a-descriptions-item>
      <a-descriptions-item label="任务描述">
        {{ modal.content }}
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ modal.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="截止时间">
        {{ modal.endTime }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="资源文件"
      :column="3"
      bordered
      style="margin-top:16px"
    >
      <a-descriptions-item label="文件列表">
        <div class="fileItem" v-for="(item, key) in list" :key="key">
          <img
            v-if="'doc' == item.fileType"
            src="@/assets/imgs/resource/btn_word.png"
            width="30"
            height="30"
          />
          <img
            v-if="'ppt' == item.fileType"
            src="@/assets/imgs/resource/btn_ppt.png"
            width="30"
            height="30"
          />
          <img
            v-if="'pdf' == item.fileType"
            src="@/assets/imgs/resource/btn_pdf.png"
            width="30"
            height="30"
          />
          <a :href="item.resourceUrl">{{ item.resourceName }}</a>
        </div>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import { toText } from "@components/_util/util";
import { resourceFiles } from "@/api/base/statistical/resource";

export default {
  data() {
    return {
      //modal
      visible: false,
      modal: {},

      list: []
    };
  },
  methods: {
    // HTML转字符串
    toText: h => toText(h),

    show(modal) {
      // console.log(" === statistic detail @ detail task resource list: ", modal);

      this.visible = true;
      this.modal = {};
      this.list = [];

      if (modal) {
        this.modal = modal;
        this.modal.content = this.modal.content
          ? this.toText(this.modal.content)
          : "";

        // 请求上传文件列表
        this.loadUpload();
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    },

    // 加载上传的资源文件列表
    loadUpload() {
      // console.log(" === loadUpload === ", this.modal);

      // resourceFile({ sunWorkId: this.modal.id }).then(res => {
      //   if (1 == res.resultCode) {
      //     this.list = res.result;
      //   }
      // });

      resourceFiles({
        sunWorkId: this.modal.id,
        arrIds: this.modal.arrIds
      }).then(res => {
        if (1 == res.resultCode) {
          this.list = res.result;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fileItem {
  margin: 6px 0;
}
</style>
